import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class LoginPatientGuard implements CanActivate {
  constructor(
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const organization = this.findOrganization(route);
    if (organization && !['paciente', undefined].includes(organization) && organization !== 'sessions') {
      this.redirectTo('/paciente/login/boas-vindas', { organization });
    }
    return of(true);
  }

  private findOrganization(route: ActivatedRouteSnapshot): string | undefined {
    return route.params['organization'] || route.parent && this.findOrganization(route.parent);
  }

  private redirectTo(path: string, queryParams = {}): void {
    this.router.navigate([path], { queryParams, queryParamsHandling: 'merge', });
  }
}
